import classNames from 'classnames/bind';
import styles from './KinhDich.module.scss';
import { getSimBatCuc, getSimBatCucCount } from '../../../services/listSim';
import { useEffect, useRef, useState } from 'react';
import { CircularProgress, Container, Grid, Hidden, Stack } from '@mui/material';
import { getLocalStorage, numberFormat } from '../../../utils/helper';
import { tomtatDuNien } from '../LogicSearch/kimKinhDich';
import { showMenhSim } from '../LogicSearch/LogicCategoryShowName';
import images from '../../../assets/images';
import { ButtonUI } from '../../../component/CustomerMUI';
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import { orderBy } from 'lodash-es';
import { useLocation, useNavigate } from 'react-router-dom';

const cx = classNames.bind(styles);
const normalizeClass = (text) => {
  if (!text || typeof text !== 'string') return ''; // fallback
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '');
};

const tuongSinhMap = {
  moc: 'Hỏa',
  hoa: 'Thổ',
  tho: 'Kim',
  kim: 'Thủy',
  thuy: 'Mộc',
};

const homeNetWork = [
  {
    titleNetWork: 'Mobifone',
    srcNetwork: images.logo_mb,
    width: '70px',
  },
  {
    titleNetWork: 'Viettel',
    srcNetwork: images.logo_vt,
    width: '70px',
  },
  {
    titleNetWork: 'Vinaphone',
    srcNetwork: images.logo_vn,
    width: '70px',
  },
  {
    titleNetWork: 'Itelecom',
    srcNetwork: images.logo_itel,
    width: '50px',
  },
  {
    titleNetWork: 'Vietnamobile',
    srcNetwork: images.logo_vnmb,
    width: '70px',
  },
  {
    titleNetWork: 'Wintel',
    srcNetwork: images.logo_wintel,
    width: '70px',
  },
];

const priceRange = [
  {
    id: 2,
    titlePrice: 'Dưới 1 triệu',
    value: '0,0.999',
  },
  {
    id: 3,
    titlePrice: '1 - 2 triệu',
    value: '1,2',
  },
  {
    id: 4,
    titlePrice: '2 - 3 triệu',
    value: '2,3',
  },
  {
    id: 5,
    titlePrice: '3 - 5 triệu',
    value: '3,5',
  },
  {
    id: 6,
    titlePrice: '5 - 10 triệu',
    value: '5,10',
  },
  {
    id: 7,
    titlePrice: '10 - 20 triệu',
    value: '10,20',
  },
  {
    id: 8,
    titlePrice: '20 - 50 triệu',
    value: '20,50',
  },
  {
    id: 9,
    titlePrice: '50 - 100 triệu',
    value: '50,100',
  },
  {
    id: 10,
    titlePrice: 'Trên 100 triệu',
    value: '100',
  },
];

const searchDauSoSim = [
  {
    dauso: '09*',
    titleDauSo: '09',
  },
  {
    dauso: '08*',
    titleDauSo: '08',
  },
  {
    dauso: '03*',
    titleDauSo: '03',
  },
  {
    dauso: '07*',
    titleDauSo: '07',
  },
  {
    dauso: '05*',
    titleDauSo: '05',
  },
];
export default function KinhDichDetail({
  diennien = '',
  menh = '',
  sim = '',
  nhamang = '',
  RangePrice = '',
  orderBy = '',
  nghenghiep = '',
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const hostname = window.location.hostname;
  const loader = useRef(null);
  const [arrSim, setArrSim] = useState([]);
  const [arrSimCount, setArrSimCount] = useState(0);
  const [page, setPage] = useState(1);
  const [objCccd, setObjCccd] = useState(null);
  const [loadingTotalSim, setLoadingTotalSim] = useState('');
  const [loading, setLoading] = useState(true);
  const [actionNetWork, setActionNetWork] = useState(nhamang);
  const [actionBtnSort, setActionBtnSort] = useState(orderBy);
  const [bgrDF, setBgrDF] = useState({ bgr: '', deg: '' });
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [openRangePrice, setOpenRangePrice] = useState(false);
  const [actionRangePriceSim, setActionRangePriceSim] = useState(RangePrice);
  const [actionRangePrice, setActionRangePrice] = useState({ startPrice: '', endPrice: '' });
  const [authDomain, setAuthDomain] = useState({});
  const [isFixed, setIsFixed] = useState(false);

  const dmySim = getLocalStorage('dmy');

  const getSimDuNien = async (diennien = '', menh = '', sim = '', nhamang = '', orderBySim = '', RangePrice = '') => {
    setLoadingTotalSim('Đang tải số lượng sim...');
    setArrSim([]);
    const resultSIM = await getSimBatCuc(hostname, 1, 60, diennien, menh, sim, nhamang, '', '', orderBySim, RangePrice);
    if (resultSIM?.datasim?.data?.length > 0) {
      setArrSim(resultSIM?.datasim?.data);
      setLoadingTotalSim('');
      fetchApiCountLocSim(diennien, menh, sim);
      if (resultSIM?.datauser?.length > 0) {
        setAuthDomain(resultSIM?.datauser[0]);
        if (resultSIM?.datauser[0]['background']) {
          setBgrDF({
            bgr: resultSIM?.datauser[0]['background']?.split(',')[0],
            deg: resultSIM?.datauser[0]['background']?.split(',')[1],
          });
          document.documentElement.style.setProperty(
            '--home-color',
            resultSIM?.datauser[0]['background']?.split(',')[0],
          );
          document.documentElement.style.setProperty(
            '--home-color-deg',
            resultSIM?.datauser[0]['background']?.split(',')[1],
          );
          document.body.style.backgroundColor = resultSIM?.datauser[0]['background']?.split(',')[0] + '0f';
        }
      }
    } else {
      setLoadingTotalSim('Không có dữ liệu Sim bạn muốn tìm');
    }
  };
  const fetchApiLocSim = async (diennien = '', menh = '', sim = '', nhamang = '', orderBySim = '', RangePrice = '') => {
    const resultSIM = await getSimBatCuc(
      hostname,
      page,
      60,
      diennien,
      menh,
      sim,
      nhamang,
      '',
      '',
      orderBySim,
      RangePrice,
    );
    if (resultSIM?.datasim?.data?.length > 0) {
      setLoadingTotalSim('Đang tải số lượng sim...');
      let arrResult = arrSim;
      setArrSim(arrResult.concat(resultSIM?.datasim?.data));
      setLoading(false);
    }
  };

  const fetchApiCountLocSim = async (diennien = '', menh = '', sim = '', nhamang = '', RangePrice = '') => {
    setArrSimCount(0);
    const resultSIM = await getSimBatCucCount(hostname, 60, diennien, menh, sim, nhamang, '', '', RangePrice);
    setArrSimCount(resultSIM);
  };

  useEffect(() => {
    if (diennien !== '' || menh !== '' || sim !== '' || nhamang !== '' || orderBy !== '' || RangePrice !== '') {
      getSimDuNien(diennien, menh, sim, nhamang, orderBy, RangePrice);
    }

    if (dmySim) {
      const dmy = {
        day: dmySim?.day || '',
        month: dmySim?.month || '',
        year: dmySim?.year || '',
        hour: dmySim?.hour || '',
        cccd: dmySim?.cccd || '',
        lich: dmySim?.lich || 'al',
        gender: dmySim?.gender || 'nam',
      };
      setObjCccd(dmy);
    }
  }, [diennien, menh, sim, nhamang, orderBy, RangePrice]);

  useEffect(() => {
    if (page !== 1 && Math.ceil(arrSimCount / 20) >= page) {
      setLoading(true);
      fetchApiLocSim(diennien, menh, sim, nhamang, orderBy, RangePrice);
    }
  }, [page]);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0,
    };

    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) observer.observe(loader.current);

    return () => observer.disconnect();
  }, [arrSim, arrSimCount]);

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting && Math.ceil(arrSimCount / 20) >= page) {
      setPage((page) => page + 1);
    }
  };

  const toggleDrawer = (open) => {
    setIsOpenDrawer(open);
  };

  const getUrl = (nhamang, order, price) => {
    // setActionBtnSort(order === '1' ? 'ASC' : order === 1 ? 'DESC' : '');
    const nghenghiepsim = nghenghiep ? `?nn=${nghenghiep}` : ``;
    const textSim = sim ? `&q=${sim}` : '';
    const menhsim = menh ? `?m=${menh}` : nghenghiepsim ? `?nn=${nghenghiep}` : `?i=`;
    const priceRange = price ? `&range=${price}` : '';
    const orderbysim = order ? `&by=${order === 'ASC' ? '1' : order === 'DESC' ? '2' : ''}` : '';
    const mang = nhamang ? `&mang=${nhamang}` : '';
    const pathname = location.pathname + menhsim + textSim + mang + orderbysim + priceRange;
    navigate(pathname, { replace: true });
  };

  return (
    <Grid item xs={12} md={12} sx={{ mb: '130px' }}>
      {arrSim.length > 0 ? (
        <Container sx={{ p: 1, m: 'auto' }} maxWidth="lg">
          <div className={cx('box-relate')}>
            <div>
              {menh ? <h3>Sim Hợp Mệnh {showMenhSim(menh)} </h3> : <h3>Bạn cũng có thể tham khảo sim</h3>}

              <div className={cx('main-content-filter-layout2')}>
                <div className={cx('main-content-filter-bgr')}>
                  <div className={cx('block-list-filter-layout', 'mb-10')}>
                    <div className={cx('box-list-subcate')}>
                      <div className={cx('list-subcate')}>
                        <Stack direction="row" spacing={1}>
                          {authDomain?.mang_show?.split(',')?.map((au, index) =>
                            homeNetWork.map(
                              (network, i) =>
                                au === network.titleNetWork && (
                                  <ButtonUI
                                    key={i}
                                    borderRadius={6}
                                    bgrColorBtn={actionNetWork === network.titleNetWork ? bgrDF.bgr + '26' : '#ffffff'}
                                    borderBtn={actionNetWork === network.titleNetWork ? bgrDF.bgr : '#44444426'}
                                    onClick={() => {
                                      network.titleNetWork !== actionNetWork
                                        ? setActionNetWork(network.titleNetWork)
                                        : setActionNetWork('');
                                      getSimDuNien(
                                        diennien,
                                        menh,
                                        sim,
                                        actionNetWork === network.titleNetWork ? '' : network.titleNetWork,
                                        actionBtnSort,
                                        actionRangePriceSim,
                                      );
                                      getUrl(network.titleNetWork, actionBtnSort, actionRangePriceSim);
                                    }}
                                  >
                                    <img src={network.srcNetwork} alt={network.titleNetWork} width={network.width} />
                                  </ButtonUI>
                                ),
                            ),
                          )}
                        </Stack>
                      </div>
                    </div>
                  </div>
                  <div className={cx('block-list-filter-layout2', 'mb-10')}>
                    <div className={cx('box-list-subcate')}>
                      <div className={cx('list-subcate')}>
                        <Stack direction="row" spacing={1}>
                          {priceRange.map((row, i) => (
                            <ButtonUI
                              key={i}
                              sx={{ mb: 1, mr: 0.5, ml: 0.5 }}
                              startIcon={<MonetizationOnIcon />}
                              bgrColorBtn={actionRangePriceSim === row.value ? bgrDF.bgr + '26' : '#F3F4F6'}
                              colorText={actionRangePriceSim === row.value ? bgrDF.bgr : '#444444'}
                              borderBtn={actionRangePriceSim === row.value ? bgrDF.bgr + '4a' : '#44444400'}
                              onClick={() => {
                                setActionRangePriceSim(actionRangePriceSim === row.value ? '' : row.value);
                                // fetchApiLocSim(
                                //   textSearch,
                                //   actionNetWork,
                                //   actionMenuCate,
                                //   actionFormatSim,
                                //   actionMenhSim,
                                //   actionBtnSort,
                                //   actionRangePriceSim === row.value ? '' : row.value,
                                //   actionTranhso.join(''),
                                // );
                                getSimDuNien(
                                  diennien,
                                  menh,
                                  sim,
                                  actionNetWork,
                                  actionBtnSort,
                                  actionRangePriceSim === row.value ? '' : row.value,
                                );
                                getUrl(actionNetWork, 'DESC', row.value);
                                setOpenRangePrice(false);
                              }}
                            >
                              {row.titlePrice}
                            </ButtonUI>
                          ))}
                        </Stack>
                      </div>
                    </div>
                  </div>
                  <div className={cx('block-list-filter-layout2')}>
                    <div className={cx('box-list-subcate')}>
                      <div className={cx('list-subcate')}>
                        <Stack direction="row" spacing={1} alignItems={'center'}>
                          <ButtonUI
                            startIcon={<FilterAltRoundedIcon />}
                            bgrColorBtn={bgrDF.bgr}
                            colorText={'#fff'}
                            borderBtn={bgrDF.bgr + '4a'}
                            onClick={() => {
                              toggleDrawer(true);
                            }}
                          >
                            Bộ Lọc
                          </ButtonUI>

                          <ButtonUI
                            startIcon={<SouthIcon />}
                            bgrColorBtn={actionBtnSort === 'ASC' ? bgrDF.bgr + '26' : '#F3F4F6'}
                            colorText={actionBtnSort === 'ASC' ? bgrDF.bgr : '#444444'}
                            borderBtn={actionBtnSort === 'ASC' ? bgrDF.bgr + '4a' : '#4444440d'}
                            onClick={() => {
                              setActionBtnSort('ASC');
                              getSimDuNien(diennien, menh, sim, actionNetWork, 'ASC', actionRangePriceSim);
                              getUrl(actionNetWork, 'ASC', actionRangePriceSim);
                            }}
                          >
                            Giá Thấp
                          </ButtonUI>
                          <ButtonUI
                            startIcon={<NorthIcon />}
                            bgrColorBtn={actionBtnSort === 'DESC' ? bgrDF.bgr + '26' : '#F3F4F6'}
                            colorText={actionBtnSort === 'DESC' ? bgrDF.bgr : '#444444'}
                            borderBtn={actionBtnSort === 'DESC' ? bgrDF.bgr + '4a' : '#4444440d'}
                            onClick={() => {
                              setActionBtnSort('DESC');
                              getSimDuNien(diennien, menh, sim, actionNetWork, 'DESC', actionRangePriceSim);
                              getUrl(actionNetWork, 'DESC', actionRangePriceSim);
                            }}
                          >
                            Giá Cao
                          </ButtonUI>

                          {/* <ButtonUI
                            startIcon={<SouthIcon />}
                            bgrColorBtn={actionBtnSort === 'DESC' ? bgrDF.bgr + '26' : '#F3F4F6'}
                            colorText={actionBtnSort === 'DESC' ? bgrDF.bgr : '#444444'}
                            borderBtn={actionBtnSort === 'DESC' ? bgrDF.bgr + '4a' : '#4444440d'}
                            onClick={() => {
                              setActionBtnSort('DESC');
                              // fetchApiLocSim(
                              //   textSearch,
                              //   actionNetWork,
                              //   actionMenuCate,
                              //   actionFormatSim,
                              //   actionMenhSim,
                              //   'DESC',
                              //   actionRangePriceSim,
                              //   actionTranhso.join(''),
                              //   thuebao,
                              // );
                            }}
                          >
                            Điểm Thấp
                          </ButtonUI>

                          <ButtonUI
                            startIcon={<NorthIcon />}
                            bgrColorBtn={actionBtnSort === 'DESC' ? bgrDF.bgr + '26' : '#F3F4F6'}
                            colorText={actionBtnSort === 'DESC' ? bgrDF.bgr : '#444444'}
                            borderBtn={actionBtnSort === 'DESC' ? bgrDF.bgr + '4a' : '#4444440d'}
                            onClick={() => {
                              setActionBtnSort('DESC');
                              // fetchApiLocSim(
                              //   textSearch,
                              //   actionNetWork,
                              //   actionMenuCate,
                              //   actionFormatSim,
                              //   actionMenhSim,
                              //   'DESC',
                              //   actionRangePriceSim,
                              //   actionTranhso.join(''),
                              //   thuebao,
                              // );
                            }}
                          >
                            Điểm Cao
                          </ButtonUI> */}
                        </Stack>
                      </div>
                    </div>
                  </div>
                  {/* {(textSearch !== '' ||
                                    actionMenuCate !== 0 ||
                                    actionMenhSim !== 0 ||
                                    actionNetWork !== '' ||
                                    actionFormatSim !== 0 ||
                                    thuebao !== '' ||
                                    actionRangePriceSim !== '' ||
                                    actionTranhso.length > 0) && (
                                    <div className={cx('block-list-filter')}>
                                      <label className={cx('block-list-filter_title')}>Đang tìm kiếm theo tiêu chí:</label>
                                      <div className={cx('box-list-subcate')}>
                                        <div className={cx('list-subcate')}>
                                          <Stack direction="row" spacing={1}>
                                            <ButtonUI
                                              startIcon={<CancelIcon />}
                                              bgrColorBtn={bgrDF.bgr + '26'}
                                              colorText={bgrDF.bgr}
                                              borderBtn={bgrDF.bgr + '4a'}
                                              onClick={() => {
                                                setActionMenhSim(0);
                                                setActionMenuCate(0);
                                                setActionNetWork('');
                                                setActionFormatSim(0);
                                                setTextSearch('');
                                                setActionRangePriceSim('');
                                                setActionTranhso([]);
                                                setSearchDauSim('');
                                                setTextSearch('');
                                                setTextSearchChange('');
                                                setCheckCoppy({});
                                                setDataImageExcel([]);
                                                fetchApiLocSim('', '', 0, '', 0, actionBtnSort, '', [], '');
                                              }}
                                            >
                                              Xóa tất cả
                                            </ButtonUI>
                                            {textSearch !== '' && (
                                              <ButtonUI
                                                startIcon={<CancelIcon />}
                                                bgrColorBtn={bgrDF.bgr + '26'}
                                                colorText={bgrDF.bgr}
                                                borderBtn={bgrDF.bgr + '4a'}
                                                onClick={() => {
                                                  setSearchDauSim('');
                                                  setTextSearch('');
                                                  setTextSearchChange('');
                                                  setCheckCoppy({});
                                                  setDataImageExcel([]);
                                                  fetchApiLocSim(
                                                    '',
                                                    actionNetWork,
                                                    actionMenuCate,
                                                    actionFormatSim,
                                                    actionMenhSim,
                                                    actionBtnSort,
                                                    actionRangePriceSim,
                                                    actionTranhso.join(''),
                                                    thuebao,
                                                  );
                                                  contextApiUser.toggleDataSim('');
                                                }}
                                              >
                                                {`Tìm sim:` + textSearch}
                                              </ButtonUI>
                                            )}
                                            {actionMenuCate !== 0 && (
                                              <ButtonUI
                                                startIcon={<CancelIcon />}
                                                bgrColorBtn={bgrDF.bgr + '26'}
                                                colorText={bgrDF.bgr}
                                                borderBtn={bgrDF.bgr + '4a'}
                                                onClick={() => {
                                                  setActionMenuCate(0);
                                                  setCheckCoppy({});
                                                  setDataImageExcel([]);
                                                  fetchApiLocSim(
                                                    textSearch,
                                                    actionNetWork,
                                                    0,
                                                    actionFormatSim,
                                                    actionMenhSim,
                                                    actionBtnSort,
                                                    actionRangePriceSim,
                                                    actionTranhso.join(''),
                                                    thuebao,
                                                  );
                                                }}
                                              >
                                                {menuSimResult.filter((x) => x.link === actionMenuCate).length > 0
                                                  ? menuSimResult.filter((x) => x.link === actionMenuCate)[0].title
                                                  : ``}
                                              </ButtonUI>
                                            )}
                                            {actionMenhSim !== 0 && (
                                              <ButtonUI
                                                startIcon={<CancelIcon />}
                                                bgrColorBtn={bgrDF.bgr + '26'}
                                                colorText={bgrDF.bgr}
                                                borderBtn={bgrDF.bgr + '4a'}
                                                onClick={() => {
                                                  setActionMenhSim(0);
                                                  setCheckCoppy({});
                                                  setDataImageExcel([]);
                                                  fetchApiLocSim(
                                                    textSearch,
                                                    actionNetWork,
                                                    actionMenuCate,
                                                    actionFormatSim,
                                                    0,
                                                    actionBtnSort,
                                                    actionRangePriceSim,
                                                    actionTranhso.join(''),
                                                    thuebao,
                                                  );
                                                }}
                                              >
                                                {arrayMenhSim.filter((x) => x.link === actionMenhSim).length > 0
                                                  ? arrayMenhSim.filter((x) => x.link === actionMenhSim)[0].title
                                                  : ``}
                                              </ButtonUI>
                                            )}
                                            {actionNetWork !== '' && (
                                              <ButtonUI
                                                startIcon={<CancelIcon />}
                                                bgrColorBtn={bgrDF.bgr + '26'}
                                                colorText={bgrDF.bgr}
                                                borderBtn={bgrDF.bgr + '4a'}
                                                onClick={() => {
                                                  setActionNetWork('');
                                                  setCheckCoppy({});
                                                  setDataImageExcel([]);
                                                  fetchApiLocSim(
                                                    textSearch,
                                                    '',
                                                    actionMenuCate,
                                                    actionFormatSim,
                                                    actionMenhSim,
                                                    actionBtnSort,
                                                    actionRangePriceSim,
                                                    actionTranhso.join(''),
                                                    thuebao,
                                                  );
                                                }}
                                              >
                                                {actionNetWork}
                                              </ButtonUI>
                                            )}
                                            {actionFormatSim !== 0 && (
                                              <ButtonUI
                                                startIcon={<CancelIcon />}
                                                bgrColorBtn={bgrDF.bgr + '26'}
                                                colorText={bgrDF.bgr}
                                                borderBtn={bgrDF.bgr + '4a'}
                                                onClick={() => {
                                                  setActionFormatSim(0);
                                                  setCheckCoppy({});
                                                  setDataImageExcel([]);
                                                  fetchApiLocSim(
                                                    textSearch,
                                                    actionNetWork,
                                                    actionMenuCate,
                                                    0,
                                                    actionMenhSim,
                                                    actionBtnSort,
                                                    actionRangePriceSim,
                                                    actionTranhso.join(''),
                                                    thuebao,
                                                  );
                                                }}
                                              >
                                                {`Dạng: ${actionFormatSim}`}
                                              </ButtonUI>
                                            )}
                                            {actionRangePriceSim !== '' && (
                                              <ButtonUI
                                                startIcon={<CancelIcon />}
                                                bgrColorBtn={bgrDF.bgr + '26'}
                                                colorText={bgrDF.bgr}
                                                borderBtn={bgrDF.bgr + '4a'}
                                                onClick={() => {
                                                  setActionRangePriceSim('');
                                                  setCheckCoppy({});
                                                  setDataImageExcel([]);
                                                  fetchApiLocSim(
                                                    textSearch,
                                                    actionNetWork,
                                                    actionMenuCate,
                                                    actionFormatSim,
                                                    actionMenhSim,
                                                    actionBtnSort,
                                                    '',
                                                    actionTranhso.join(''),
                                                    thuebao,
                                                  );
                                                }}
                                              >
                                                {actionRangePriceSim
                                                  ? priceRange9.find((price) => price.value === actionRangePriceSim)?.titlePrice ||
                                                    numberFormatText(actionRangePrice.startPrice) +
                                                      ' - ' +
                                                      numberFormatText(actionRangePrice.endPrice)
                                                  : 'Khoảng giá'}
                                              </ButtonUI>
                                            )}
                                            {actionTranhso.length > 0 && (
                                              <ButtonUI
                                                startIcon={<CancelIcon />}
                                                bgrColorBtn={bgrDF.bgr + '26'}
                                                colorText={bgrDF.bgr}
                                                borderBtn={bgrDF.bgr + '4a'}
                                                onClick={() => {
                                                  setActionTranhso([]);
                                                  setCheckCoppy({});
                                                  setDataImageExcel([]);
                                                  fetchApiLocSim(
                                                    textSearch,
                                                    actionNetWork,
                                                    actionMenuCate,
                                                    actionFormatSim,
                                                    actionMenhSim,
                                                    actionBtnSort,
                                                    actionRangePriceSim,
                                                    '',
                                                    thuebao,
                                                  );
                                                }}
                                              >
                                                {`Tránh số: ${actionTranhso}`}
                                              </ButtonUI>
                                            )}
                                            {thuebao !== '' && (
                                              <ButtonUI
                                                startIcon={<CancelIcon />}
                                                bgrColorBtn={bgrDF.bgr + '26'}
                                                colorText={bgrDF.bgr}
                                                borderBtn={bgrDF.bgr + '4a'}
                                                onClick={() => {
                                                  setActionTranhso([]);
                                                  setCheckCoppy({});
                                                  setDataImageExcel([]);
                                                  fetchApiLocSim(
                                                    textSearch,
                                                    actionNetWork,
                                                    actionMenuCate,
                                                    actionFormatSim,
                                                    actionMenhSim,
                                                    actionBtnSort,
                                                    actionRangePriceSim,
                                                    actionTranhso.join(''),
                                                    '',
                                                  );
                                                  setThuebao('');
                                                }}
                                              >
                                                {`Thuê bao: ${thuebao}`}
                                              </ButtonUI>
                                            )}
                                          </Stack>
                                        </div>
                                      </div>
                                    </div>
                                  )} */}
                </div>
              </div>
            </div>

            <Grid container>
              {arrSim?.map((row, i) => (
                <Grid key={i} item xs={12} md={4} sx={{ display: 'flex' }}>
                  <section className={cx('simtt')} style={{ flex: 1, display: 'flex' }}>
                    <div className={cx('boxSimInfor')} style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                      <div className={cx('title-sim', 'flex-center-1')}>
                        <div className={cx('flex-center-1', 'h-right')}>
                          <div className={cx('h-mang', `${row?.nhamang}`)}>
                            {row?.nhamang === 'Vietnammobile' ? 'VNMB' : row?.nhamang}
                          </div>
                          <div className={cx('h-sim')}>
                            {row?.sim_show}
                            {row?.price && (
                              <div className={cx('h-gia')}>
                                Giá: <strong className={cx('price-last')}>{numberFormat(row?.price)}₫</strong>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className={cx('h-left')}>
                          {row?.menh_sim && (
                            <div className={cx('sub-nguhanh', `${row.menh_sim?.split(',')[0] + '-size'}`)}>
                              <strong className={cx('uppercase')}>{showMenhSim(row.menh_sim?.split(',')[0])} </strong>
                            </div>
                          )}
                          {row?.score && (
                            <div className={cx('h-diem')}>
                              Điểm<strong className={cx('h-diem-so')}>{row?.score}</strong>
                            </div>
                          )}
                        </div>
                      </div>

                      <p className={cx('text-que-dich')}>Từ trường cuối sim</p>
                      <div className={cx('summary-tags', 'justifyCenter')}>
                        <span className={cx('sim-tag', 'mt-10', `energy-${normalizeClass(row.cap_duoi)}`)}>
                          {row.cap_duoi}
                        </span>
                      </div>
                      <p className={cx('text-y-nghia', 'mt-10')}>{tomtatDuNien[row.cap_duoi]?.yes}</p>

                      <div className={cx('dunien-content')} />

                      <p className={cx('text-que-dich')}>Từ trường trong sim</p>
                      <div className={cx('summary-tags', 'justifyCenter', 'mb-20')}>
                        {row?.dunienin_sim &&
                          row?.dunienin_sim?.split(',').map((t, i) => (
                            <span key={i} className={cx('sim-tag', 'mt-10', `energy-${normalizeClass(t)}`)}>
                              {t}
                            </span>
                          ))}
                      </div>

                      <div className={cx('g-btn', 'flex-center-1')} style={{ marginTop: 'auto' }}>
                        <a rel="nofollow" className={cx('btn-pt')} href={`/s/${row.sim}`} title={row.sim}>
                          Đặt mua sim
                        </a>
                        <a
                          rel="nofollow"
                          className={cx('btn-pt')}
                          href={`/xem-phong-thuy?so=${row.sim}${objCccd?.cccd ? `&cccd=${objCccd?.cccd}` : ''}${
                            objCccd?.day
                              ? `&ngay=${objCccd?.day}&thang=${objCccd?.month}&nam=${objCccd?.year}&gio=${objCccd?.hour}`
                              : ''
                          }${objCccd?.gender ? `&gioitinh=${objCccd?.gender}` : ''}${
                            objCccd?.isLunar ? `&lich=al` : `&lich=dl`
                          }`}
                          title={`xem boi sim ${row.sim}`}
                        >
                          Luận giải sim
                        </a>
                      </div>
                    </div>
                  </section>
                </Grid>
              ))}
            </Grid>
            <div ref={loader}>
              {loading && (
                <div className={cx('css-load-sim')}>
                  <CircularProgress color="inherit" size={20} />
                  <b className={cx('pl-1')}>Tải dữ liệu...</b>
                </div>
              )}
            </div>
          </div>
        </Container>
      ) : (
        loadingTotalSim && (
          <div className={cx('no-text')}>
            <span>{loadingTotalSim}</span>
          </div>
        )
      )}
    </Grid>
  );
}
